export { default as About } from "./about";
export { default as Hero } from "./hero";
export { default as NewsLetter } from "./newsLetter";
export { default as Values } from "./values";
export { default as Landscape } from "./landscape";
export { default as Team } from "./team";
export { default as Partners } from "./partners";
export { default as Quote } from "./quote";
